module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/asset_fiscal.a3ed015d.png";